import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, Footer, ProcModal } from '@sonyged/ext-proc';
import { HamburgerMenu } from '@sonyged/proc-ui';

class ProcMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };
  }

  render() {
    return (
      <React.Fragment>
        <HamburgerMenu position="absolute" top={0} left={0} zIndex={2} onClick={this._onClick.bind(this)} />
        {this._renderMenuText()}
        <ProcModal rootNodeId={this.props.rootNodeId} isOpened={this.state.isOpened}>
          <div key="modal" className={'proc-modal menu large sushi'} onClick={this._onClose.bind(this)}>
            <div className={'modal-contents'}>
              <div className={'title-container'}>
                <div className={'title secondary20-color proc-medium-font'}>{this.props.title}</div>
                <div className={'desc white-color proc-huge-font'}>{this.props.subTitle}</div>
              </div>
            </div>
            <Footer.normal className="modal-footer" shadow={false}>
              <Button.dark
                onClick={() => {
                  this.props.push({
                    pathname: this.props.exitLink,
                    search: this.props.query,
                  });
                }}
              >
                やめる
              </Button.dark>
              <Button.attention className={'modal-close-se'} onClick={this._onClose.bind(this)}>
                つづける
              </Button.attention>
            </Footer.normal>
          </div>
        </ProcModal>
      </React.Fragment>
    );
  }

  _renderMenuText() {
    if (!this.props.menuText) {
      return <span />;
    }
    return <div className={'proc-menu-title proc-small-font secondary100-color'}>{this.props.menuText}</div>;
  }

  _onClick(e) {
    e.stopPropagation();
    this.setState({ isOpened: true });
  }

  _onClose(e) {
    e.stopPropagation();
    this.setState({ isOpened: false });
  }
}

ProcMenu.propTypes = {
  exitLink: PropTypes.string,
  query: PropTypes.string,
  menuText: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  rootNodeId: PropTypes.string,
  push: PropTypes.func,
};

ProcMenu.defaultProps = {
  className: '',
  exitLink: '/',
  query: '',
  style: {},
  rootNodeId: 'proc-page-root',
};

export default connect(null, dispatch => ({
  push: input => dispatch(push(input)),
}))(ProcMenu);
